import * as React from 'react';
import { useSelector } from 'react-redux';
import { Tabs } from '@cian/ui-kit/prev';

import { DepartmentLink, TransportAccessibilitySidebar } from '../../../../components/Map/parts/TransportAccessibility';
import { getTransportAccessibilitySource } from '../../../../selectors/newbuilding';
import { ETransportAccessibilityTab, TTAInfrastructureType } from '../../../../types/map';
import { TransportAccessibilityInside } from '../TransportAccessibilityInside';
import { TransportAccessibilityOutside } from '../TransportAccessibilityOutside';
import { useTransportAccessibilityTabs } from './hooks';
import { trackDepartmentLinkClick, trackTabChange } from '../../analytics';

export interface ITransportAccessibilitySidebarContainerProps {
  onClose: () => void;
  onTransportAccessibilityChange: (infrastructureType: TTAInfrastructureType | null) => void;
}

export const TransportAccessibilitySidebarContainer: React.FC<ITransportAccessibilitySidebarContainerProps> = ({
  onClose,
  onTransportAccessibilityChange,
}) => {
  const tabs = useTransportAccessibilityTabs();
  const [activeTab, setActiveTab] = React.useState<string>(tabs[0].value);

  const hasVisibileTabs = tabs.length > 1;

  const changeTab = React.useCallback((tab: string) => {
    setActiveTab(tab);
    trackTabChange(tab);
  }, []);

  const departmentLink = useSelector(getTransportAccessibilitySource);
  const handleDepartmentLinkClick = React.useCallback(() => trackDepartmentLinkClick(activeTab), [activeTab]);

  return (
    <TransportAccessibilitySidebar
      onClose={onClose}
      tabs={hasVisibileTabs && <Tabs activeTab={activeTab} onChange={changeTab} tabs={tabs} />}
      transportDepartmentLink={
        <DepartmentLink href={departmentLink} onClick={handleDepartmentLinkClick} size="small" />
      }
    >
      {activeTab === ETransportAccessibilityTab.Outside && (
        <TransportAccessibilityOutside onTransportAccessibilityChange={onTransportAccessibilityChange} />
      )}
      {activeTab === ETransportAccessibilityTab.Inside && (
        <TransportAccessibilityInside onTransportAccessibilityChange={onTransportAccessibilityChange} />
      )}
    </TransportAccessibilitySidebar>
  );
};
